import { useContext } from 'react';

import {
  NotificationContext,
  NotificationType,
} from 'providers/NotificationProvider';

const useNotification = () => {
  const { setIsVisible, setNotificationType, setMessage, setTitle } =
    useContext(NotificationContext);

  const showDefaultNotification = (title: string, message: string) => {
    setNotificationType(NotificationType.DEFAULT);
    showNotification(title, message);
  };

  const showSuccessNotification = (title: string, message: string) => {
    setNotificationType(NotificationType.SUCCESS);
    showNotification(title, message);
  };

  const showWarningNotification = (title: string, message: string) => {
    setNotificationType(NotificationType.WARNING);
    showNotification(title, message);
  };

  const showErrorNotification = (title: string, message: string) => {
    setNotificationType(NotificationType.ERROR);
    showNotification(title, message);
  };

  const showNotification = (title: string, message: string) => {
    setMessage(message);
    setTitle(title);
    setIsVisible(true);
  };

  return {
    showDefaultNotification,
    showSuccessNotification,
    showWarningNotification,
    showErrorNotification,
  };
};

export default useNotification;
